import React from 'react';
import whatsapp from '../../assets/whatsapp.svg';

export default function Phone() {
  const whatsappBengaluru = "919606158631";
  const whatsappDelhi = "919868336833";

  return (
    <div className="phone-no-box">
      <div className="phone-contact">

        <img
          src={whatsapp}
          alt="WhatsApp"
          className="phone-icon"
        />

        <div className="phone-number-list">
          <a
            href={`https://wa.me/${whatsappBengaluru}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-link"
          >
            +91 96 0615 8631 (Bengaluru)
          </a>

          <a
            href={`https://wa.me/${whatsappDelhi}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-link"
          >
            +91 98 6833 6833 (Delhi)
          </a>
        </div>

      </div>
    </div>
  );
}